module.exports = __webpack_public_path__ + "img/providerConnectWidget.e5763c58.png";